var map = {
	"./achievment.svg": "2a70",
	"./arrowDown.svg": "955a",
	"./arrowRight.svg": "059f",
	"./arrowupdown.svg": "5e22",
	"./calendar.svg": "2be6",
	"./check.svg": "f26c",
	"./clock.svg": "3343",
	"./close.svg": "f62a",
	"./courses.svg": "f2d8",
	"./dashboard.svg": "f108",
	"./dots.svg": "7f8f",
	"./exam.svg": "0e73",
	"./examsummary.svg": "8498",
	"./facebook.svg": "917d",
	"./friends.svg": "aaaf",
	"./google.svg": "6743",
	"./graph.svg": "af3d",
	"./light.svg": "ccc1",
	"./logo.svg": "ce80",
	"./logout.svg": "38c1",
	"./message.svg": "3555",
	"./night.svg": "ee1e",
	"./schedule.svg": "7e54",
	"./search.svg": "77aa",
	"./settings.svg": "27f4",
	"./sign.svg": "c024",
	"./time.svg": "5636",
	"./user.svg": "6fa1"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | icons */ "icons").then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "568e";
module.exports = webpackAsyncContext;